<template>
	<div>
		<!-- banner -->
		<div class="banner">
			<!-- <el-carousel :height="bannerHeight+'px'"> -->
			<el-carousel :height="bannerHeight+'px'">
				<el-carousel-item v-for="(item, index) in sliders" :key="index">
					<img style="width:100%;height: auto" :src="item.img" class="slider_img"
						@click="getOpenMinChengXuLink">
				</el-carousel-item>
			</el-carousel>
			<!-- apply form -->
			<div class="apply">
				<div class="form-t">
					<p class="title">借款申请</p>BORROWING APPLICATIO
				</div>
				<div class="apply-ipt">
					<img class="ipt-img" src="../../static/home/user_name.png" alt="" />
					<el-input class="ipt" v-model="userName" placeholder="请输入您的姓名" clearable></el-input>
				</div>
				<div class="apply-ipt">
					<img class="ipt-img" src="../../static/home/phone_number.png" alt="" />
					<el-input class="ipt" v-model="userPhone" placeholder="请输入您的手机号" clearable></el-input>
				</div>
				<div class="verification-code">
					<div class="apply-ipt code-ipt">
						<el-input class="ipt" v-model="code" placeholder="请输入验证码" clearable></el-input>
					</div>
					<img @click="getCode" class="img" :src="img" alt="" />
				</div>
				<div class="apply-btn" @click="submit()">立即申请</div> 	
			</div>
		</div>
		<!-- icons -->
		<div class="quick_wrap">
			<div class="inner">
				<ul class="quick_list">
					<li class="wow fadeIn">
						<img class="quick_ico" src="../../static/home/icon01.png" alt="" />
						<div class="quick_info">
							<span class="quick_info_t">借款热线</span>
							<br>拨打解决您的周转难题<a class="col_orange"><br>0551-6287-6666</a><br>
						</div>
					</li>
					<li class="wow fadeIn">
						<img class="quick_ico" src="../../static/home/icon02.png" alt="" />
						<div class="quick_info">
							<span class="quick_info_t">立即借款</span>
							<br>解燃眉之急 <span><br>就选联丰典当行</span> 
						</div>
					</li>
					<li class="wow fadeIn">
						<img class="quick_ico" src="../../static/home/icon03.png" alt="" />
						<div class="quick_info">
							<span class="quick_info_t">合作渠道入口</span>
							<br>额度高 门槛低<span><br>息费低 收费透明</span>
						</div>
					</li>
					<li class="wow fadeIn">
						<img class="quick_ico" src="../../static/home/icon04.png" alt="" />
						<div class="quick_info">
							<span class="quick_info_t">典当问答</span>
							<br>能不能借款<span><br>了解典当的相关知识!</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<!-- 典当产品 -->
		<div class="head-label">
			<div class="f36">典当产品</div>
			<div class="f14 red">PAWN PRODUCTS</div>
		</div>
		<div class="border_parent products-index" @click="handleLink('/pawnProducts')">
			<div class="left">
				<a class="c-fff" href="#car">
					<div class="left_t left_img">
						<p class="f30 blod">我有车</p>
						<p class="f18">全款车、按揭车、公司车等皆可做</p>
						<p class="f18">方便灵活 专业可靠 1小时可到账</p>
					</div>
				</a>
			</div>
			<div class="right">
				<a class="c-fff" href="#house">
					<div class="right_img img01">
						<div class="right_img_t">
							<p class="f28 blod">我有房</p>
							<p class="f16">住宅、商业、办公、别墅等</p>
							<p class="f16">一抵、二抵均可做</p>
						</div>
					</div>
				</a>
				<a class="c-fff" href="#gold">
					<div class="right_img img02">
						<div class="right_img_t">
							<p class="f28 blod">我有珠宝首饰、奢侈品</p>
							<p class="f16">随借随还 息费低</p>
							<p class="f16">在线评估 可上门</p>
						</div>
					</div>
					<div class="right_img img03">
						<div class="right_img_t">
							<p class="f28 blod">我有数码产品</p>
							<p class="f16">手机、电脑、平板、相机、无人机等</p>
							<p class="f16">短期应急周转 可上门</p>
						</div>
					</div>
				</a>
			</div>
		</div>
		<!-- 服务优势 -->
		<div class="head-label">
			<div class="f36">服务优势</div>
			<div class="f14 red">SERVICE ADVANTAGES</div>
		</div>
		<div class="border_parent service">
			<div class="service_a">
				<img src="../../static/home/advantage01.png" alt="" />
				<div class="service_t1">
					<p class="f24 blod">借款额高</p>
					<p class="f14 c-6">不查征信、只看物品价值、顶额借款满</p>
					<p class="f14 c-6">足客户需求</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage02.png" alt="" />
				<div class="service_t2">
					<p class="f24 blod">放款迅速</p>
					<p class="f14 c-6">汽车业务1小时可到账、房产业务8小时</p>
					<p class="f14 c-6">可到账、在线民品典当秒到账</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage03.png" alt="" />
				<div class="service_t1">
					<p class="f24 blod">方便灵活</p>
					<p class="f14 c-6">手续简便、随借随还、审批条件灵活</p>
				</div>
			</div>
			<div class="service_a">
				<img src="../../static/home/advantage04.png" alt="" />
				<div class="service_t2">
					<p class="f24 blod">专业可靠</p>
					<p class="f14 c-6">20余年专业品质、实力雄厚、典当行业</p>
					<p class="f14 c-6">协会会员单位</p>
				</div>
			</div>
		</div>
		<!-- 贷款流程 -->
		<Process></Process>
		<!-- 热门问答，快速链接 -->
		<div class="questions">
			<div class="questions_con">
				<div class="left">
					<div>
						<p class="f36 blod">热门问答</p>
						<p class="f14 red blod">POPULAR SEARCHES</p>
						<img src="../../static/home/line1.png" alt="" />
					</div>
					<span @click="activeIndex = 0" :class="activeIndex == 0 ? 'current' : ''" class="questions_t">典当小贴士</span>
					<span @click="activeIndex = 1" :class="activeIndex == 1 ? 'current' : ''" class="questions_t">典当流程</span>
					<span @click="activeIndex = 2" :class="activeIndex == 2 ? 'current' : ''" class="questions_t">需要哪些材料</span>
					<div v-if="activeIndex == 0" class="questions_arr">
						<div class="question_Q flex">
							<p class="item_t blod f14">什么是典当？</p>
							<span class="question_ico ml-10">Q</span>
						</div>
						<div class="question_A flex">
							<div class="question_ico mr-10">A</div>
							<p class="item_t des f12">
								所谓典当，是指当户将其动产、财产权利作为当物质押或者抵押给典当行，交付一定比例费用，取得当金，并在约定期限内支付当金利息、偿还当金、赎回当物的行为。通俗的说，典当就是要以财物作质押，有偿有期借贷融资的一种方式。这是一种以物换钱的融资方式，只要顾客在约定时间内还本并支付一定的综合服务费(包括当物的保管费、保险费、利息等)，就可赎回当物。
							</p>
						</div>
						<div class="question_Q flex">
							<p class="item_t blod f14">什么东西可以典当，典当行有那些业务？</p>
							<span class="question_ico ml-10">Q</span>
						</div>
						<div class="question_A flex">
							<div class="question_ico mr-10">A</div>
							<p class="item_t des f12">
								原则上只要来源合法、产权明晰、可以依法疏通的有价值物品或财产权利都可以典当，但不同典当行具体开展的业务有不同，一般来讲房产、车辆、金银饰品、珠宝钻石、电子产品、腕表、奢侈品包包、数码产品等都可以典当。
							</p>
						</div>
						<div class="question_Q flex">
							<p class="item_t blod f14">典当借款同银行贷款的区别？</p>
							<span class="question_ico ml-10">Q</span>
						</div>
						<div class="question_A flex">
							<div class="question_ico mr-10">A</div>
							<p class="item_t des f12">
								1、业务方式上，典当更加灵活多样，原则上有价值的物品或财产权利都可以典当;<br />
								2、典当借款手续简便快捷，一般少则几分钟，多则三五天;<br />
								3、借款用途不一样，典当借款多用于救急，银行贷款多用于生产或消费:<br />
								4、典当一般期限较短，最短15天，最长6个月;<br />
								5、典当一般除收取当金利息外，还按当金一定比例收取综合费。
							</p>
						</div>
					</div>
					<div v-if="activeIndex == 1" class="questions_arr">
						<div class="question_Q flex">
							<p class="item_t blod f14">典当是什么流程？</p>
							<span class="question_ico ml-10">Q</span>
						</div>
						<div class="question_A flex">
							<div class="question_ico mr-10">A</div>
							<p class="item_t des f12">
								其基本流程为可简单归纳为交当、收当、存当三个步骤，具体操作程序如下:<br/>
								1、当户出具有效证件交付当物。<br/>
								2、典当行受理当物进行鉴定。<br/>
								3、双方约定评估价格、当金数额和典当期限并确认法定息费标准<br/>
								4、双方共同清点封存当物由典当行保管。<br/>
								5、典当行向当户出具当票发放当金。
							</p>
						</div>
					</div>
					<div v-if="activeIndex == 2" class="questions_arr">
						<div class="question_Q flex">
							<p class="item_t blod f14">典当需要提供哪些材料？</p>
							<span class="question_ico ml-10">Q</span>
						</div>
						<div class="question_A flex">
							<div class="question_ico mr-10">A</div>
							<p class="item_t des f12">
								不同典当业务需要提供材料是不一样的:<br/>
								1、民品：本人身份证原件，有发票最好，可适当提高当价。<br/>
								2、车辆：本人身份证、汽车相关证件。<br/>
								3、房产：户主身份证、户口本、房屋所有权证、土地使用证等，需现场察看房产<br/>
								注：民品即金银饰品、珠宝钻石、电子产品、奢侈品包表、数码产品、古钱币等<br/>
							</p>
						</div>
					</div>
				</div>
				<div class="right">
					<div>
						<p class="f36 blod">快速链接</p>
						<p class="f14 red blod">QUICK LINKS</p>
						<img src="../../static/home/line2.png" alt="" />
					</div>
					<div class="link_arr">
						<div v-for="(item, i) in linkArr" :key="i" class="link_item" @click="handleLink(item.path)">
							<p class="f16 red blod">{{ item.name }}</p>
							<img class="icon_img" :src="item.icon" alt="" />
							<img class="small_img" src="../../static/home/small.png" alt="" />
							<img class="big_img none" src="../../static/home/big.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 合作机构 -->
		<div class="head-label">
			<div class="f36">合作机构</div>
			<div class="f14 red">SERVICE ADVANTAGES</div>
		</div>
		<div class="border_parent cooperate">
			<div class="scroll-container">
				<div class="scroll-content">
					<div class="scroll-item" v-for="(item, i) in cooperate" :key="i">
						<img class="cooperate_item_img" :src="item" alt="" />
					</div>
				</div>
		    </div>
			<!-- <div class="cooperate_arr" v-for="(item, i) in cooperate" :key="i">
				<div class="cooperate_item">
					<img class="cooperate_item_img" :src="item" alt="" />
				</div>
			</div> -->
		</div>
		<Dialog :centerDialogVisible="centerDialogVisible" @close="close"></Dialog>
	</div>
</template>
<script>	
	import ApplyForm from './ApplyForm.vue'
	import Process from './Process.vue'
	import Dialog from './Dialog.vue'
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
import { error } from 'shelljs'
	export default {
		name: 'Index',
		components: {ApplyForm,Process, Dialog},
		data() {
			return {
				activeIndex: 0,
				centerDialogVisible: false,
				userName: '',
				userPhone: '',
				code: '',
				// 容器的高度
				bannerHeight: 0,
				// 瀏覽器寬度
				screeWith: 0,
				sliders: [],
				processArr: [{
						img: require('../../static/home/1.png'),
						title: "申请",
						name: '添加客服微信'
					},
					{
						img: require('../../static/home/2.png'),
						title: "评估",
						name: '提交物品详情'
					},
					{
						img: require('../../static/home/3.png'),
						title: "审核",
						name: '即时审批额度'
					},
					{
						img: require('../../static/home/4.png'),
						title: "放款",
						name: '借款迅速到账'
					},
				],
				// 热门问答
				questionsArr: [
					{
						title: '贷款小贴士',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					},
					{
						title: '我能贷款吗',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					},
					{
						title: '如何还款',
						questions: [{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						},
						{
							Q: '如何防止套路贷？',
							A: '在现实生活中一些民间借贷机构为了谋取不正当的利益，会设下圈套让借款者陷入到套路贷中，通过签订明显不合理的合同，让借款者需要偿还的借款越来越多，那么如何防止套路贷?下面由华夏典当行为读者进行相关知识的解答。1、选择合法正规途径：借款时就会夏典当行为读者进行相关知识的解答。1、选择合法正规关知识的解答。1、选择合法正规途径：借款时就会…'
						}]
					}
				],
				// 链接
				linkArr: [
					{
						icon: require('../../static/home/quick_links01.png'),
						name: '快速申请',
						path: '/myPawn'
					},
					{
						icon: require('../../static/home/quick_links02.png'),
						name: '渠道合作',
						path: '/channel'
					},
					{
						icon: require('../../static/home/quick_links03.png'),
						name: '典当问答',
						path: '/answer'
					},
					{
						icon: require('../../static/home/quick_links04.png'),
						name: '门店信息',
						path: '/walkInto'
					}
				],
				// 合作机构
				cooperate: [
					require('../../static/home/institution01.png'),
					require('../../static/home/institution02.png'),
					require('../../static/home/institution03.png'),
					require('../../static/home/institution04.png'),
					require('../../static/home/institution05.png'),
					require('../../static/home/institution06.png'),
					require('../../static/home/institution07.png'),
					require('../../static/home/institution08.png'),
				],
				images: [{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/数据分析.png'),
						title: "查询报价",
						content: ["系统自动检测估价", "专业检测师免费评估"]
					}, {
						img: require('../../static/other/用户构建.png'),
						title: "当面评估",
						content: ["全程免费为您服务", "允许可免费上门服务"]
					},
					{
						img: require('../../static/other/品牌渠道.png'),
						title: "快速寄存",
						content: ["专柜封存", "简单 方便 快捷 安全"]
					}
				],
				spec: {
					img: require('../../static/other/arrow.png'),
					product: [{
							img: require('../../static/other/手指.png'),
							title: "一键操作",
							contents: ["一键延期或买回", "操作方便快捷安全"]
						},
						{
							img: require('../../static/other/店铺管理.png'),
							title: "一键延期",
							contents: ["系统实时监控寄存状态", "自动检测延期金额和差价"]
						},
						{
							img: require('../../static/other/用户构建.png'),
							title: "一键买回",
							contents: ["校验买回码", "支付买回费用"]
						},
						{
							img: require('../../static/other/助力零售.png'),
							title: "平台核查",
							contents: ["检测师核对买回信息", "顺丰发货业务灵活方便"]
						}
					]
				},
				img: '',
				uuid: '',
				scrollContent: ''
				// carousel_height: '550px',
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}
		
		},
		created() {
			this.getCode()
		},
		mounted() {
			this.sliders = [{
					img: require("../../static/home/banner01.png")
				}],
			// 首次加載時，初始化高度
			this.screeWith = window.innerWidth
			this.bannerHeight = 560 / 1920 * this.screeWith
			// 窗口大小發生變化
			window.onresize = () => {
				this.screeWith = window.innerWidth
				this.bannerHeight = 560 / 1920 * this.screeWith
			}
			this.scrollContent = document.querySelector('.scroll-content');
			const scrollItemWidth = document.querySelector('.scroll-item').offsetWidth;
			const scrollItemsCount = document.querySelectorAll('.scroll-item').length;
			const totalWidth = scrollItemWidth * scrollItemsCount;
			this.scrollContent.innerHTML += this.scrollContent.innerHTML; // 复制一份内容，实现无缝滚动
			this.scrollContent.addEventListener('animationend', this.resetScroll());
		},
		methods: {
			handleLink(path) {
				this.$router.push({
					path: path
				});
			},
			resetScroll() {
			    this.scrollContent.style.transform = 'translateX(0)';
			}, 
			close(flag) {
				this.centerDialogVisible = flag
			},
			async getCode() {
				let res = await this.util.request({
					url: `/sy/getLfWebsite/formCode`,
					method: 'GET',
					data: {},
				});
				if (res.status === 200) {
					this.img = res.data.img;
					this.uuid = res.data.uuid;
				} 
			},
			submit() {
				if (this.userName == '') {
					this.$message.error('请输入姓名');
					return false
				}
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				if (this.code == '') {
					this.$message.error('请输入验证码');
					return false
				}
				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 1,
						userName: this.userName,
						userPhone: this.userPhone,
						clueType: 0,
						uuid: this.uuid,
						code: this.code,
					},
				}).then(res => {
					if (res.status === 200) {
						this.centerDialogVisible = true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const CheckCsrf = encryptLong(sySign + timeStamp);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
	}
</script>

<style scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #CF2427 !important;
	}
	
	.slider_img {
		height: 560px;
		width: 100%;
	}

	/* banner FORM style */
	.banner {
		position: relative;
	}

	.apply {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateY(-50%);
		margin-left: 180px;
		z-index: 99;
		background: rgba(0, 0, 0, .3);
		border-radius: 8px;
		padding: 40px;
	}

	.form-t {
		font-size: 14px;
		color: #CF2427;
		margin-bottom: 20px;
	}

	.form-t .title {
		font-weight: 600;
		font-size: 26px;
		color: #FFFFFF;
	}

	.apply-ipt {
		padding: 0 11px;
		height: 44px;
		line-height: 44px;
		background: #FFFFFF;
		border-radius: 22px;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}

	.ipt-img {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}
	
	.ipt::placeholder {
		color: #999;
	}
	
	/deep/ .el-input .el-input__inner {
		border: none;
		font-size: 13px;
		color: #333;
		padding: 0;
	}

	.apply-btn {
		width: 234px;
		height: 44px;
		line-height: 44px;
		background: #CF2427;
		border-radius: 22px;
		font-weight: 600;
		font-size: 15px;
		color: #FFFFFF;
		text-align: center;
	}
	
	.verification-code {
		display: flex;
	}
	.code-ipt {
		width: 105px;
		margin-right: 10px;
	}
	.verification-code .img {
		cursor: pointer;
		width: 94px;
		height: 44px;
		background: #FFFFFF;
	}
	
	/* icons */
	.quick_wrap {
		background-color: #fff;
		padding: 30px 0;
	}
	.inner {
	    width: 1200px;
	    margin: 0 auto;
	}
	.quick_list {
		display: flex;
		align-items: center;
	}
	.quick_ico {
	    margin-right: 20px;
	    width: 66px;
	    height: 66px;
	}
	.quick_list li {
	    width: 25%;
		display: flex;
		align-items: center;
	}
	.quick_info {
		overflow: hidden;
		font-size: 14px;
		color: #666666;
		line-height: 22px;
	}
	.quick_info_t {
		font-weight: 600;
		font-size: 16px;
		color: #333333;
	}
	.col_orange {
	    color: #CF2427;
	}
	.col_orange_t {
		
	}
	.quick_link {
	    display: block;
	    margin-top: 6px;
	    font-family: SourceHanSansCN_Medium, Microsoft YaHei, "微软雅黑";
	}
	.solve {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.border {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		height: auto;
		margin: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.border_one {
		margin-left: 0;
	}

	.border_img_parent {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.product_mobile_content {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.product_mobile_img {
		width: 50%;
	}

	.product_mobile_title {
		font-weight: bold;
		text-align: center;
	}

	.product_pc_one {
		text-align: center;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.font_size_30 {
		font-size: 1.875rem;
	}

	.product_font_style {
		font-size: 1.125rem;
	}

	.product_pc_img {
		width: 100%
	}

	.product_pc_img_div {
		width: 50%;
		float: left;
		display: flex;
		align-items: center;
	}

	.product_pc {
		display: flex;
		width: 90%;
		margin: 20px auto;
		background: #F2F6FC;
		align-items: center;
	}

	.product_spec_title {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.cooperation_parent {
		display: flex;
		justify-content: center;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.border_spec {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		float: left;
		width: 25%;
		height: auto;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.about_me_p {
		font-size: 1.25rem;
		font-weight: normal;
		padding: 0 20px;
		margin: 10px;
	}

	.border_title {
		font-family: "PingFang SC";
		margin-top: 10px;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
	}

	.border_content_one {
		margin-top: 20px;
		font-size: 1.125rem;
		text-align: center;
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125rem;
		margin-bottom: 25px;
		text-align: center;
	}

	.img_border {
		margin-top: 15px;
		width: 80px;
		height: 80px
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 35px;
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		text-align: center;
	}

	.border_spec_inner_last {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		margin-bottom: 25px;
		text-align: center;
	}

	.cooperation {
		margin-top: 30px;
		width: 100%;
	}

	.about_me {
		display: flex;
		margin-top: 30px;
		justify-content: center;
		width: 100%;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		background: #F2F6FC;
	}

	.product_mobile_img_div {
		width: 50%;
		height: auto;
	}

	.product_mobile_content_one {
		margin-top: 20px;
		text-align: center;
	}

	.product_mobile_content_two {
		margin-top: 10px;
		text-align: center;
	}

	/* 屏幕设备适配 max-device-width: 400px */
	@media screen and (max-device-width: 415px) {
		.slider_img {
			height: 250px;
			width: 100%;
		}


		.border_parent {
			display: flex;
			width: 90%;
			margin: auto;
			height: auto;
			flex-direction: column;
		}

		.border {
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			float: left;
			width: 100%;
			height: auto;
			margin: 10px 0 auto;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
				/*background: aquamarine;*/
		}

		.border_img_parent {
			margin-top: 0;

		}

		.product_mobile {
			width: 90%;
			align-items: center;
			margin: 20px auto;
			height: auto;
			background: #F2F6FC;
		}

		.product_mobile_content {
			width: 100%;
			margin-top: 15px;
		}

		.product_mobile_content_one {
			margin-top: 5px;
		}

		.product_mobile_content_two {
			margin-top: 5px;
		}

		.product_mobile_img_div {
			display: flex;
			width: 100%;
			height: auto;
			justify-content: center;
			margin-top: 10px;
			margin-bottom: 15px;
		}

		.product_mobile_img {
			float: left;
		}

		.product_mobile_title {
			font-weight: bold;
		}

		.product_pc_one {
			width: 100%;
			margin-top: 15px;
		}

		.font_size_30 {
			font-size: 1.25rem;
		}

		.product_font_style {
			font-size: 1rem;
		}

		.product_pc_img {
			height: 280px;
			width: 320px;
		}

		.product_pc_img_div {
			width: 100%;
			float: left;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;
		}

		.product_pc {
			display: flex;
			width: 90%;
			height: auto;
			margin: 20px auto;
			background: #F2F6FC;
			flex-direction: column;
		}

		

		.product_spec_parent {
			display: flex;
			width: 90%;
			align-items: center;
			justify-content: center;
			margin: 20px auto;
			height: auto;
			flex-direction: column;
		}

		.border_spec {
			float: left;
			height: auto;
			margin: 8px;
			width: 100%;
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}


		.border_title {
			font-family: "PingFang SC";
			margin-top: 5px;
			font-size: 1.125rem;
			font-weight: bold;
		}

		.border_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
		}

		.border_content_two {
			margin-top: 5px;
			font-size: 1.125rem;
			margin-bottom: 8px;
		}

		.img_border {
			margin-top: 8px;
			width: 80px;
			height: 80px
		}

		.border_spec_inner_one {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 8px;
			/*background-color: aqua;*/
			height: 70px;
		}

		.border_spec_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
		}

		.border_spec_inner_last {
			/*background-color: bisque;*/
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
			margin-bottom: 8px;
		}

		.about_me {
			display: flex;
			margin-top: 10px;
			width: 100%;
		}
	}

	.border_spec_img {
		width: 75px;
		height: 55px;
		align-self: center
	}

	.font_size_24 {
		font-size: 1.5rem;
	}
	/* 合作机构 */
	.scroll-container {
		width: 100%;
		overflow: hidden; /* 隐藏超出容器范围的内容 */
		white-space: nowrap; /* 防止内容换行 */
	}
	.scroll-content {
	    /* display: inline-block; */
		display: flex;
		align-items: center;
	    animation: scroll-animation 15s linear infinite; /* 应用动画，15s完成一次滚动，线性速度，无限循环 */
	}
	.scroll-item {
	    display: flex;
		align-items: center;
		justify-content: center;
		padding: 30px 44px;
		background: #FFFFFF;
		border-radius: 8px;
	    margin-right: 20px; /* 滚动项之间的间距 */
	}
	.cooperate_item_img {
		width: 197px;
		height: 81px;
	}
	@keyframes scroll-animation {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(calc(-100% - 20px)); /* 计算滚动距离，这里假设间距为20px */
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue